/** Organization slugs seeded in `LegalEntity`. */
export const ORG_SLUG = {
  WAPHARMA: 'wapharma',
  HAMSSAH: 'hamssah',
} as const;

export type OrgSlug = (typeof ORG_SLUG)[keyof typeof ORG_SLUG];

export type OrgEntityIds = {
  wapharmaId: string;
  hamssahId: string;
};

/** Default invoice/selling entity by sales channel (overridable per order). */
export function defaultOrderEntityIds(
  channel: string,
  ids: OrgEntityIds,
): { sellingEntityId: string; invoiceEntityId: string } {
  const ch = channel.trim().toUpperCase();
  if (ch === 'B2B') {
    return { sellingEntityId: ids.wapharmaId, invoiceEntityId: ids.wapharmaId };
  }
  return { sellingEntityId: ids.hamssahId, invoiceEntityId: ids.hamssahId };
}

/** Stock owner entity for ATP by channel (showroom = Hamssah local, ecommerce = WaPharma entrepôt). */
export function stockOwnerSlugForChannel(channel?: string | null): OrgSlug {
  const ch = (channel ?? '').trim().toUpperCase();
  if (ch === 'SHOWROOM') return ORG_SLUG.HAMSSAH;
  return ORG_SLUG.WAPHARMA;
}

/**
 * Reservations that compete for the same physical ATP pool as `requestChannel`.
 * Reserve checks must subtract all of these (not only the request channel) —
 * ECOMMERCE + B2B share WaPharma stock; SHOWROOM uses Hamssah (ST-4).
 */
export function filterReservationsForStockOwner<T extends { channel: string }>(
  reservations: T[],
  requestChannel?: string | null,
): T[] {
  const owner = stockOwnerSlugForChannel(requestChannel);
  return reservations.filter((r) => stockOwnerSlugForChannel(r.channel) === owner);
}

export type OrgWorkspace = 'hamssah-retail' | 'wapharma-ops';

export function workspaceForOrgSlug(slug: string | null | undefined): OrgWorkspace {
  return slug === ORG_SLUG.HAMSSAH ? 'hamssah-retail' : 'wapharma-ops';
}
